module.exports = __webpack_public_path__ + "img/green.dcd5606a.jpg";